exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.card--shadow[data-v-33964c44] {\n  box-shadow: 0px 3px 4px #00000029;\n}\n.card__body[data-v-33964c44] {\n  flex: 1;\n}\n.card__body--grow[data-v-33964c44] {\n  flex-grow: 1;\n}\n.card__footer[data-v-33964c44] {\n  background: #f8f9fa;\n  border-top: 1px solid #edeef0;\n}", ""]);

// exports
